const list = {
    path: 'list',
    component: resolve => require(['@/pages/admin/my_service_order/list'], resolve),
    meta: {
        requireAuth: true
    }
}

export default list